export default __webpack_public_path__ + "static/media/logo-mobile.8cef3882.svg";